import { useAPIQuery, DesignsDraftApi } from "melco-shared-logic";

export const useDesignReferences = (designId: string) => {
  return useAPIQuery(
    DesignsDraftApi,
    ["designReferences", designId],
    async (api) => api.userDesignsReferences({ id: designId })
  );
};
